// Tandem agent entries — same disk semantics as workspace local; delegates to AgentEntriesTool with forced support.

import { TandemTool } from "../../base/TandemTool.js";
import { AgentEntriesTool } from "../../../workspace/implementations/agents/AgentEntriesTool.js";

class TandemAgentEntriesDelegate extends AgentEntriesTool {
  _supportsAgentEntries() {
    return true;
  }
}

export class TandemAgentEntriesTool extends TandemTool {
  constructor() {
    super();
    this.toolName = "agentEntriesTool";
    this._delegate = new TandemAgentEntriesDelegate();
  }

  _bindDelegate() {
    this._delegate.toolSystem = this.toolSystem;
  }

  async ensureAgentsReadme() {
    this._bindDelegate();
    return this._delegate.ensureAgentsReadme();
  }

  async readReadmeBody() {
    this._bindDelegate();
    return this._delegate.readReadmeBody();
  }

  async writeReadmeBody(body) {
    this._bindDelegate();
    return this._delegate.writeReadmeBody(body);
  }

  async collectAgentContextForOverview(latestEntryCount) {
    this._bindDelegate();
    const out = await this._delegate.collectAgentContextForOverview(latestEntryCount);
    if (
      out &&
      typeof out === "object" &&
      out.agentsPresent === false &&
      out.readmeNote === "No /agents folder in the workspace yet."
    ) {
      return { ...out, readmeNote: "No /agents folder in the project yet." };
    }
    return out;
  }

  async readEntry(entryNumber) {
    this._bindDelegate();
    return this._delegate.readEntry(entryNumber);
  }

  async readEntryRange(startNumber, endNumber) {
    this._bindDelegate();
    return this._delegate.readEntryRange(startNumber, endNumber);
  }

  async writeEntry(entryNumber, content, readmeSummary) {
    this._bindDelegate();
    return this._delegate.writeEntry(entryNumber, content, readmeSummary);
  }
}
